export default __webpack_public_path__ + "static/world-4-2dd5e11e52566345eb97c2d176fff6ff.jpg";